import api from './api';

/**
 * Notification API — preferences and in-app notifications.
 * Backed by /api/v1/notifications (NotificationController).
 */
const notificationService = {
  // Preferences (auto-created server-side with defaults on first GET)
  getPreferences: async () => {
    const response = await api.get('/api/v1/notifications/preferences');
    return response.data?.data ?? response.data;
  },

  // Partial update — only send the fields being changed
  updatePreferences: async (prefs) => {
    const response = await api.put('/api/v1/notifications/preferences', prefs);
    return response.data?.data ?? response.data;
  },

  // Sends a test in-app notification to the current user
  sendTest: async () => {
    const response = await api.post('/api/v1/notifications/test');
    return response.data?.data ?? response.data;
  },
};

export default notificationService;
